const navbar = {
  logOut: "退出登录",
  dashboard: "首页",
  screenfull: "全屏地图",
  task: "监控急救任务",
  theme: "换肤",
  size: "布局大小"
} 
export default navbar